import { restPostClient } from "./RestClient";

function normalizeQuestionType(type) {
	const normalizedType = String(type || "").trim().toLowerCase();

	if (["text", "textarea", "description"].includes(normalizedType)) {
		return "text";
	}

	if (["rating", "nps"].includes(normalizedType)) {
		return "rating";
	}

	if (normalizedType === "radio") {
		return "radio";
	}

	return "checkbox";
}

function normalizeBoolean(value) {
	if (typeof value === "boolean") {
		return value;
	}

	return String(value || "").trim().toLowerCase() === "true";
}

function normalizeFeedbackQuestion(question) {
	return {
		id:
			question?.id ??
			question?.Id ??
			question?.questionId ??
			question?.QuestionId,
		question: question?.question ?? question?.Question ?? "",
		questionDescription:
			question?.questionDescription ?? question?.QuestionDescription ?? "",
		options: question?.options ?? question?.Options ?? "[]",
		otherOptions: normalizeBoolean(
			question?.otherOptions ?? question?.OtherOptions,
		),
		type: normalizeQuestionType(question?.type ?? question?.Type),
	};
}


export async function fetchFeedbackQuestions(userId) {
	const payload = {
		PageNr: 1,
		NrOfRecPerPage: 20,
		FullSearch: "",
		UserId: userId,
		IncludeRecordNr: "true",
		TypeOfObjectReturned: "",
		SearchList: [],
		SortList: [
			{
				FieldName: "Id",
				Direction: "asc",
			},
		],
	};
	const res = await restPostClient("Users/FetchFeedbackQuestions", payload);
	return Array.isArray(res.data)
		? res.data.map((question) => normalizeFeedbackQuestion(question))
		: [];
}
export async function fetchFeedbackStatus(feedbackId, userId) {
	const payload = {
		UserId: userId,
		FeedbackId: feedbackId,
	}
	const res = await restPostClient("Users/FetchIsSubmitUserFeedback", payload);
	return res;
}


export async function saveFeedbackQuestions(userId, feedbackId, saveList) {
	const payload = {
		UserId: userId,
		FeedbackId: feedbackId,
		ReturnRecordId: true,
		ReturnRecordError: true,
		SaveList: saveList,
	};
	const res = await restPostClient("Users/SaveFeedbackAnswers", payload);
	return res;
}
